import UniversalSearchModal from "./UniversalSearchModal.vue";

export * from "./types";
export * from "./UniversalSearchService";

export default UniversalSearchModal;
